import { normalizeHeader } from "./parseSpreadsheet";

/** @typedef {{ id: string, label: string, detect: (headers: string[]) => boolean, columnMap: Record<string, string> }} ImportPreset */

/** Klimakompasset export: sheet "Data (alle poster)" — English column titles */
export const PRESET_KLIMAKOMPASSET = {
  id: "klimakompasset",
  label: "Klimakompasset",
  detect(headers) {
    const lower = new Set(
      headers.map((h) => normalizeHeader(h).toLowerCase())
    );
    return (
      lower.has("main category") &&
      lower.has("amount") &&
      lower.has("unit")
    );
  },
  columnMap: {
    "Main category": "route_main",
    Category: "route_category",
    Subcategory: "route_subcategory",
    Description: "description",
    Amount: "quantity",
    Unit: "unit",
    "Total emissions": "tco2e",
    "Scope 1 - factor": "skip_scope1",
    "Scope 2 - factor": "skip_scope2",
    "Scope 3 - factor": "skip_scope3",
    "Outside of scope - factor": "skip_outside",
    "Parameter 2": "gas_type",
    "Parameter 2 - title": "skip_param2_title",
    Parameter: "skip_param_title",
  },
};

/** @type {ImportPreset[]} */
export const IMPORT_PRESETS = [PRESET_KLIMAKOMPASSET];

export function detectPreset(headers) {
  return IMPORT_PRESETS.find((p) => p.detect(headers)) || null;
}

export function mergePresetIntoMapping(preset, headers) {
  const out = {};
  if (!preset) return out;
  const map = preset.columnMap;
  for (const h of headers) {
    const n = normalizeHeader(h);
    if (map[n] != null) {
      const target = map[n];
      if (String(target).startsWith("skip")) continue;
      out[h] = target;
    }
  }
  return out;
}
